// extracted by mini-css-extract-plugin
export default {"editbeer":"style_editbeer__6ARyG","comment":"style_comment__O+29b","textblock":"style_textblock__NkQip","btn1":"style_btn1__XbuWI"};